import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input<{ placeholderOpacity?: number }>`
  ${({ placeholderOpacity }) =>
    placeholderOpacity
      ? `
      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        opacity: ${placeholderOpacity}
      }
      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        opacity: ${placeholderOpacity}
      }
      ::-ms-input-placeholder { /* Microsoft Edge */
        opacity: ${placeholderOpacity}
      }
    `
      : null}
`;

interface Props {
  hint?: string;
  password?: boolean;
  value: string;
  maxLength?: number;
  onChange: Function;
  onKeyPress?: Function;
  className?: string | 'form-control';
  disabled?: boolean;
  reference?: any;
  placeholderOpacity?: number;
}

export const InputText = (props: Props) => {
  const {
    hint,
    password,
    value,
    maxLength,
    onChange,
    onKeyPress,
    className,
    disabled,
    reference,
    placeholderOpacity,
  } = props;
  return (
    <StyledInput
      type={password ? 'password' : 'text'}
      className={className}
      placeholder={hint}
      value={value}
      onChange={(e) => {
        onChange(e.target.value, e);
      }}
      onKeyPress={(e) => {
        if (onKeyPress) {
          onKeyPress(e);
        }
      }}
      ref={reference}
      maxLength={maxLength}
      style={{ width: '100%' }}
      disabled={disabled}
      placeholderOpacity={placeholderOpacity}
    />
  );
};
